import {mapState} from 'vuex'

export default {
  props:{
    isReminder:{
      type: Boolean,
      default: false
    },
    fileList:{
      type: [Array,Object],
      default: ()=>[]
    }
  },
  computed:{
    showRenewalInsurer(){
      return editType==3||this.isReminder
    },
    has_file(){
      return (type)=>{
        let list = this.fileList.filter(item=>item.type == type)||[]
        return list.length>0
      }
    }
  }
}
